export type EventType = 'webinar' | 'workshop' | 'training'

export interface Event {
  id: string
  title: {
    en: string
    id: string
  }
  description: {
    en: string
    id: string
  }
  date: string
  time: string
  type: EventType
  location: {
    en: string
    id: string
  }
  speaker: string
  isFeatured?: boolean
}

export const events: Event[] = [
  {
    id: 'ev-001',
    title: {
      en: 'Cyber Security Basics for Gen Z',
      id: 'Dasar Keamanan Siber untuk Gen Z',
    },
    description: {
      en: 'Learn the fundamentals of digital safety, password management, and how to spot common online scams.',
      id: 'Pelajari dasar-dasar keamanan digital, manajemen password, dan cara mengenali penipuan online umum.',
    },
    date: '2024-03-15',
    time: '14:00 WIB',
    type: 'webinar',
    location: {
      en: 'Online via Zoom',
      id: 'Online via Zoom',
    },
    speaker: 'Sarah Wijaya (Cyber Security Analyst)',
    isFeatured: true,
  },
  {
    id: 'ev-002',
    title: {
      en: 'Workshop: Securing Your Social Media',
      id: 'Workshop: Mengamankan Media Sosialmu',
    },
    description: {
      en: 'Hands-on workshop to configure privacy settings and 2FA on Instagram, TikTok, and Twitter.',
      id: 'Workshop praktik langsung untuk mengatur privasi dan 2FA di Instagram, TikTok, dan Twitter.',
    },
    date: '2024-03-20',
    time: '10:00 WIB',
    type: 'workshop',
    location: {
      en: 'Digital Hub BSD',
      id: 'Digital Hub BSD',
    },
    speaker: 'Budi Santoso (Ethical Hacker)',
  },
  {
    id: 'ev-003',
    title: {
      en: 'Anti-Scam Ambassador Training',
      id: 'Pelatihan Duta Anti-Scam',
    },
    description: {
      en: 'Intensive training for those who want to become community leaders in fighting digital fraud.',
      id: 'Pelatihan intensif bagi yang ingin menjadi pemimpin komunitas dalam melawan penipuan digital.',
    },
    date: '2024-04-05',
    time: '09:00 - 16:00 WIB',
    type: 'training',
    location: {
      en: 'Jakarta Convention Center',
      id: 'Jakarta Convention Center',
    },
    speaker: 'Tim GenZAFE',
  },
  {
    id: 'ev-004',
    title: {
      en: 'Crypto & NFT Scams: How to Stay Safe',
      id: 'Penipuan Kripto & NFT: Cara Tetap Aman',
    },
    description: {
      en: 'Deep dive into the world of Web3 scams and how to protect your digital assets.',
      id: 'Kupas tuntas dunia penipuan Web3 dan cara melindungi aset digitalmu.',
    },
    date: '2024-04-12',
    time: '19:00 WIB',
    type: 'webinar',
    location: {
      en: 'Online via Zoom',
      id: 'Online via Zoom',
    },
    speaker: 'Alex Tan (Blockchain Expert)',
  },
  {
    id: 'ev-005',
    title: {
      en: 'Digital Parenting: Protecting Kids Online',
      id: 'Digital Parenting: Melindungi Anak Online',
    },
    description: {
      en: 'Guide for parents and older siblings to create a safe digital environment for children.',
      id: 'Panduan bagi orang tua dan kakak untuk menciptakan lingkungan digital yang aman bagi anak.',
    },
    date: '2024-04-20',
    time: '15:00 WIB',
    type: 'webinar',
    location: {
      en: 'Online via Google Meet',
      id: 'Online via Google Meet',
    },
    speaker: 'Dr. Rina M.Psi (Psychologist)',
  },
]
